import { Menu } from '@clds/icon';
import { PrimaryMenuItemMobile } from '../PrimaryMenu';
import { useSideMenu } from '../SideMenu/SideMenu.context';

export const SideMenuMobileTrigger = () => {
  const { toggleOpenState } = useSideMenu();

  return (
    <PrimaryMenuItemMobile analyticsMessage="mobile menu button" onClick={toggleOpenState}>
      <Menu />
    </PrimaryMenuItemMobile>
  );
};
